import script from "./WellbeingContent.vue?vue&type=script&setup=true&lang=js"
export * from "./WellbeingContent.vue?vue&type=script&setup=true&lang=js"

import "./WellbeingContent.vue?vue&type=style&index=0&id=49e3d820&lang=css"

const __exports__ = script;

export default __exports__